/**
 * Agent aktifken ekranın 4 kenarında ince neon çizgi.
 */
export function NeonBorder({ active }: { active: boolean }) {
  if (!active) return null;
  const line = 'pointer-events-none fixed z-[9998] bg-[#0F99FD]';
  const glow = '0 0 12px 2px rgba(15,153,253,0.85), 0 0 30px 6px rgba(15,153,253,0.45)';
  return (
    <>
      <style>{`@keyframes neonPulse{0%,100%{opacity:.65}50%{opacity:1}}`}</style>
      <div className={`${line} left-0 right-0 top-0 h-[3px]`} style={{ boxShadow: glow, animation: 'neonPulse 1.8s ease-in-out infinite' }} />
      <div className={`${line} left-0 right-0 bottom-0 h-[3px]`} style={{ boxShadow: glow, animation: 'neonPulse 1.8s ease-in-out infinite' }} />
      <div className={`${line} top-0 bottom-0 left-0 w-[3px]`} style={{ boxShadow: glow, animation: 'neonPulse 1.8s ease-in-out infinite' }} />
      <div className={`${line} top-0 bottom-0 right-0 w-[3px]`} style={{ boxShadow: glow, animation: 'neonPulse 1.8s ease-in-out infinite' }} />
    </>
  );
}
